export default __webpack_public_path__ + "static/media/HomeGraphic.4636cf06.png";